import { arrowLeft, arrowRight, } from "../../../../constant/icons"
import { wizardStepActionType, wizardStepType } from "../../type"

const Footer = (props: any) => {
  const { currentStep, onStepUpdate } = props

  return (<div className="btn-box maping-btn-box">
    <div>{currentStep > wizardStepType.BrowserFile && <button className="btn btn-outline-dark" title="Back" type="submit" onClick={() => { onStepUpdate(wizardStepActionType.back) }}>{arrowLeft.icon} Back</button>}</div>
    <div>
      {currentStep === wizardStepType.FunctionMap ? (
        <button className="btn btn-primary" title="Submit" type="submit" onClick={() => onStepUpdate(wizardStepActionType.next)}>Submit {arrowRight.icon}</button>
      ) : (
        <button className="btn btn-primary" title="Next" type="submit" onClick={() => onStepUpdate(wizardStepActionType.next)}>Next {arrowRight.icon}</button>
      )}
    </div>
  </div>)
}
export { Footer }